import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    standalone: false
})
export class SuccessDialogComponent {
    @Input() message: string;

    @Input() buttonText: string;
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private golbalEventService: GlobalEmittersService
    ) {}

    closeModal() {
        this.golbalEventService.refreshMatrix.next(true);
        this.ngbActiveModal.close(true);
    }
    closeDialogWithCancel() {
        this.ngbActiveModal.close(false);
    }
}
